<div mat-dialog-content>

    <div class="row  m-0 p-0">

        <div class="col-md-12">
            <div class="closebtn" (click)="close()">
               <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28" fill="none">
                            <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                            <path
                                d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                fill="#1E1515" />
                        </svg>
            </div>
            <form [formGroup]="callBackForm">
                <div class="form_full_course">

                    <h5>Fill in the form for a Quick Call back.</h5>


                    <div class="enq_filds">
                        <mat-form-field  class="example-full-width">
                            <input matInput type="text" placeholder="Enter name" formControlName="name" autocomplete="off">
                        </mat-form-field>
                    </div>

                    <div class="enq_filds">
                        <mat-form-field  class="example-full-width">
                            <input matInput type="email" placeholder="Enter email" formControlName="email" autocomplete="off">
                        </mat-form-field>
                    </div>

                    <div class="enq_filds">
                        <mat-form-field  class="example-full-width">
                            <input matInput minlength="10" maxlength="10" placeholder="Enter phone number" formControlName="phone"
                                autocomplete="off">
                        </mat-form-field>
                    </div>

                    <div class="enq_filds">
                        <mat-form-field  class="example-full-width">
                            <mat-select placeholder="Select Course" formControlName="course">
                               
                                <mat-option value="CUET UG">
                                    CUET(UG)
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- <h6>
                        I authorize Indrajeet's iQuanta Edu Services and its representatives to call, SMS, Email or WhatsApp me about its products and offers.This consent overrides any registration for DND and NDNC.
                    </h6> -->
                    
                    <button class="mt-3 w-100" [disabled]="submittedBtn" mat-flat-button color="primary"
                        (click)="callback()">Quick Call Back</button>

                </div>
            </form>

        </div>

    </div>

</div>